<template>
  <span>
    <span
      v-if="is_infant(traveler)"
      v-html="svg_infant('#35A8E0', 17)"
      style="margin-top: -2.5px"
    ></span>
    <span
      v-else-if="is_child(traveler)"
      v-html="svg_child('#35A8E0', 17)"
      style="margin-top: -2.5px"
    ></span>
    <span v-else v-html="svg_traveler('#35A8E0', 17, 17)" style="margin-top: -2.5px"></span>
  </span>
</template>

<script>
import { is_child, is_infant } from '@/utilities';
import { traveler, infant, child } from '@/components/svg/user';

export default {
  name: 'traveler-icon',
  props: {
    traveler: Object,
  },
  data() {
    return {
      svg_infant: infant,
      svg_child: child,
      svg_traveler: traveler,
    };
  },
  methods: {
    is_infant,
    is_child,
  },
};
</script>

<style lang="scss" scoped></style>
